import { createMutationHelper } from '@utils/swr'
import { type FastOrderCartSubmissionBody, type FastOrderMallRequest } from '../types/apiRequest'
import { type FastOrderCartSubmissionResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['post']['fastOrderCartSubmission'], FastOrderCartSubmissionResponse, FastOrderCartSubmissionBody, FastOrderMallRequest>({
  client: 'fortune',
  key: params => params?.mall_code ? `/cross-brand-malls/${params.mall_code}/fast-order/cart-submission` : null,
  fetcher: (url, { arg, client }) => client.post(url, arg),
})

export const useApiFastOrderCartSubmission = useMutation
